<template>
    <div class="popup" v-show="uploadCsvShow">
        <div class="content" id="uploadCsv" >
             <div class="title">
                 {{$t('language.paySystem.Notice')}}
                  <div class="icon white-close dialog-close" @click="closePage()"></div>
             </div>
             <div class="delete-remind-content">
                  <div style="float:left;width:100%;height:80px;color:#494949;line-height:20Px"> {{noticeTxt}} <span @click="downloadcSV()" class="downLoad-link">{{$t('language.teamTransfer.csvFormat')}}</span></div>
                  <div style="float:left;" class="team-footer">
                      <div class="uploadCsv-botton">
                      <div class="uploadCsv-txt">
                          <div  class="icon-util tab-float" :class="check?'check-small':'nocheck-small-blue'" @click.stop="dontShow()"></div>
                          {{$t('language.teamTransfer.dontShow')}}
                      </div>
                      <button class="uploadCsv-botton-right"  @click="ok()">{{$t('language.common.ok')}}</button>
                      </div>
                  </div>
             </div>
        </div>
    </div>
</template>
<script>
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data(){
        return{
       uploadCsvShow:false,
       noticeTxt:this.$t('language.teamTransfer.csvFile'),
       check:false,
     
      }
    },
    methods:{
      closePage(){
      this.uploadCsvShow = false;
     
      },
      ok(){
        var user = commonUtils.getUser();
      if(this.check){
          localStorage.setItem(user.id+'uploadShow',this.check);
      }else{
          localStorage.removeItem(user.id +'uploadShow');
      }
        let input_file = document.getElementById("openFile");
        input_file.click();
       this.closePage();
      },
        downloadcSV(){
        var $eleForm = $("<form method='Get'></form>");
        var url = commonstate.apiUrl + "/business_transfer/csv_sample/";
        $eleForm.attr("action", url);
        $(document.body).append($eleForm);
        $eleForm.submit();
        },
     dontShow(){
          this.check = !this.check;
          this.$forceUpdate();
     }
    }
}
</script>
<style>
   .delete-remind-content {
    width: 100%;
    height: 150Px;
    box-sizing: border-box;
    padding: 20px 15px;
    /*no*/
    font-size: 14px;
    /*no*/
}
 #uploadCsv {
    width: 510Px;
    height: 190Px;
}
.uploadCsv-footer{
 width: 100%;
 height: 40Px;
}
.uploadCsv-botton{
  display: flex;
  align-items: center; /*定义body的元素垂直居中*/
  justify-content: center; /*定义body的里的元素水平居中*/
  position: relative;
}
.uploadCsv-botton-right,.uploadCsv-botton-right:hover{
 border-radius:2px;
 margin-right:30px;
 background: #5562b4;
 color: #fff;
 width: 80Px;
 border: 1Px solid #5562b4;
 position: absolute;
 right: 0;
 margin: auto;
 top: 0;
}
.uploadCsv-botton-left{
  border-radius:2px;
  background: #5562b4;
  color: #fff;
  width: 120Px;
  margin-right: 20Px;

}
.uploadCsv-txt{
    position: absolute;
    left: 0;
     margin: auto;
     top: 8Px;
     color:#494949;
}
.downLoad-link{
    color: #5562b4;
  
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/team_transfer_popups/upload_csv_popups.vue